import { useEffect, useState } from 'react';

// Política de privacidade honesta e curta (LGPD): só o que de fato acontece.
export default function Privacidade() {
  const [cfg, setCfg] = useState<{ responsible_name: string; responsible_email: string | null; company_legal_name: string; cnpj: string | null } | null>(null);
  useEffect(() => {
    fetch('/api/settings/public')
      .then((r) => r.json())
      .then((d) => setCfg((d as { settings: null }).settings ?? null))
      .catch(() => setCfg(null));
  }, []);

  return (
    <main className="mx-auto max-w-2xl px-6 py-16 text-sm leading-relaxed">
      <h1 className="text-2xl font-semibold tracking-tight">Política de privacidade</h1>
      <p className="mt-6">
        {cfg?.company_legal_name ?? 'Meta Telecom'} coleta apenas os dados que você informa no pedido de análise
        (empresa, contato, email, telefone, CNPJ opcional, estimativas e, se você enviar, o arquivo da sua conta
        de telefonia), com a única finalidade de prepará-la e fazer o contato de resposta.
      </p>
      <ul className="mt-4 list-disc pl-5 space-y-1.5">
        <li>Usamos seus dados <strong>somente</strong> para a análise pedida e a resposta em até 24h úteis.</li>
        <li><strong>Não vendemos e não compartilhamos</strong> seus dados com terceiros, nem para marketing.</li>
        <li>O arquivo da conta é revisado apenas por nosso time, para a análise.</li>
        <li>Pediu e desistiu? Escreva para nós e apagamos tudo; sua solicitação será atendida.</li>
      </ul>
      <p className="mt-6">
        Responsável pelo tratamento (LGPD): <strong>{cfg?.responsible_name ?? 'Igor Bessa'}</strong>{' '}
        {cfg?.responsible_email ? (
          <>
            ; contato: <a href={`mailto:${cfg.responsible_email}`} className="underline underline-offset-2 hover:text-[var(--accent)]">{cfg.responsible_email}</a>
          </>
        ) : (
          <>; entre pelo formulário que você usou e identifique o pedido de exclusão.</>
        )}
      </p>
      <p className="mt-2 text-xs text-[var(--text-dim)]">
        Base legal: consentimento do titular no ato do envio (LGPD, Lei 13.709/2018). Esta página não substitui
        orientação jurídica; ajuste com seu advogado quando necessário.
      </p>
      <a href="/" className="mt-8 inline-block text-sm underline underline-offset-2 hover:text-[var(--accent)]">Voltar à página principal</a>
    </main>
  );
}
